module.exports = __webpack_public_path__ + "src/img/timer/8ebffc77759cc61b5762aadcbc045482.png";